import React, { ImgHTMLAttributes, useState } from "react";
import { ImageLoaderImg, ImageLoaderSpan } from "./styled";

const ImageLoader: React.FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  src,
  alt,
}) => {
  const [showImage, setShowImage] = useState(false);

  return (
    <>
      <img
        src={src}
        onLoad={() => {
          setShowImage(true);
        }}
        alt={alt}
      />

      <ImageLoaderSpan show={showImage}>
        <ImageLoaderImg src="/images/icons/spinner.svg" alt="icon loader" />
      </ImageLoaderSpan>
    </>
  );
};

export default ImageLoader;
